export default __webpack_public_path__ + "static/media/İsmail.2d9354f3.jpg";